import { reminder } from "../../../model/reminder";

export interface IState {
    reminders: Array<reminder>;
    selectedContactReminders: Array<reminder>;
    isLoadingReminders: boolean;
    // openDialog: boolean;
}


export const DefaultState = (): IState => ({
    reminders: [],
    selectedContactReminders: [],
    isLoadingReminders: false,
    // openDialog: false,
})
